module.exports = __webpack_public_path__ + "img/ticket-left.c7e027b4.png";